// Central design tokens for the portfolio.
// Modern, professional "software architect" palette:
// deep ink navy base, indigo primary, cyan accent, warm amber highlight.

export const colors = {
  bg: "#0b1120",          // page background (deep ink)
  bgAlt: "#0f172a",       // alternate section background
  surface: "#111a2e",     // card surface on dark
  surfaceLight: "#ffffff",
  border: "rgba(148, 163, 184, 0.16)",
  borderStrong: "rgba(148, 163, 184, 0.28)",

  ink: "#e2e8f0",         // primary text on dark
  inkSoft: "#94a3b8",     // secondary text on dark
  inkMute: "#64748b",     // muted text

  primary: "#6366f1",     // indigo
  primaryDark: "#4f46e5",
  accent: "#22d3ee",      // cyan
  accentDark: "#06b6d4",
  amber: "#fbbf24",
  green: "#34d399",
  rose: "#fb7185",

  // gradients
  gradPrimary: "linear-gradient(135deg, #6366f1 0%, #22d3ee 100%)",
  gradInk: "linear-gradient(135deg, #0b1120 0%, #0f172a 60%, #111a2e 100%)",
};

export const font = {
  sans: '"Poppins", "Inter", system-ui, -apple-system, sans-serif',
  mono: '"JetBrains Mono", "Fira Code", ui-monospace, SFMono-Regular, Menlo, monospace',
};

// Standard horizontal padding used across sections
export const pagePx = { xs: 3, sm: 4, md: 8, lg: 14, xl: 22 };
